export const YES_NO_OPTIONS = [
  { title: "Yes", value: true },
  { title: "No", value: false },
];

export const SAVINGS_ACCOUNTS_NUMBER_USED = [
  { title: "1", value: 1 },
  { title: "2", value: 2 },
  { title: "3", value: 3 },
  { title: "4", value: 4 },
  { title: "5", value: 5 },
  { title: "6", value: 6 },
  { title: "7", value: 7 },
  { title: "8", value: 8 },
  { title: "9", value: 9 },
  { title: "10", value: 10 },
  { title: "11", value: 11 },
  { title: "12", value: 12 },
];

export const TENURE_OPTIONS = [
  { title: "Freehold (most houses)", value: "freehold" },
  { title: "Leasehold (most flats)", value: "leasehold" },
  {
    title: "Leasehold with a share of the freehold",
    value: "leasehold with share of freehold",
  },
];

// Bump this whenever the text in JunoTermsAndConditions changes. It is shown to the client at the
// foot of the terms and sent with every conveyancing signup, so the staff app records which
// version each client accepted. The staff app knows the service from the signup itself.
export const TERMS_AND_CONDITIONS_VERSION_NUMBER = "1.82";
export const TERMS_AND_CONDITIONS_VERSION = TERMS_AND_CONDITIONS_VERSION_NUMBER;

export const TERMS_AND_CONDITIONS_OPTIONS = [
  {
    title: "I’ve read the terms and conditions and I accept them",
    value: true,
    name: "termsAndConditions",
  },
];

export const SELLING_REJECTION_OPTIONS = [
  {
    title: "Selling a shared ownership home: part-owned by a housing association (owning with a partner doesn’t count)",
    value: "a shared ownership property",
    name: "sharedOwnership",
  },
  {
    title: "Selling at auction",
    value: "a property at auction",
    name: "auctionSale",
  },
  {
    title: "Selling land that isn’t registered with the Land Registry (rare)",
    value: "unregistered land",
    name: "unregisteredLand",
  },
];

export const SELLING_REJECTION_MAP = new Map(SELLING_REJECTION_OPTIONS.map((i) => [i.name, i.value]));

export const BUYING_REJECTION_OPTIONS = [
  {
    title: "Buying at auction",
    value: "a property at auction",
    name: "auction",
  },
  {
    title: "Buying land that isn’t registered with the Land Registry (rare)",
    value: "unregistered land",
    name: "unregisteredLand",
  },
];

// Right to Buy is asked as its own Yes/No question, not a checkbox, but shares
// the sorry page, so it is added to the map rather than the options.
export const BUYING_REJECTION_MAP = new Map([
  ...BUYING_REJECTION_OPTIONS.map((i) => [i.name, i.value]),
  ["rightToBuy", "the Right to Buy or Right to Acquire schemes"],
]);

// Note: We also have another list of lenders in app/constants/lender.go that you will need to modify
// if editing this list!!
// The values here have to match the values in the corresponding workflow field
// choices.
export const MORTGAGE_LENDER_OPTIONS = [
  {
    title: "Accord",
    value: "Accord",
  },
  {
    title: "Aldermore",
    value: "Aldermore",
  },
  {
    title: "April Mortgages",
    value: "April Mortgages",
  },
  {
    title: "Atom Bank",
    value: "Atom Bank",
  },
  {
    title: "Bank of Ireland",
    value: "Bank of Ireland",
  },
  {
    title: "Bank of Scotland",
    value: "Bank of Scotland",
  },
  {
    title: "Barclays",
    value: "Barclays",
  },
  {
    title: "Better Homeownership",
    value: "Better Homeownership",
  },
  {
    title: "Birmingham Midshires",
    value: "Birmingham Midshires",
  },
  {
    title: "Britannia",
    value: "Britannia",
  },
  {
    title: "Buckinghamshire Building Society",
    value: "Buckingham Building Society",
  },
  {
    title: "Cambridge Building Society",
    value: "Cambridge Building Society",
  },
  {
    title: "Chelsea Building Society",
    value: "Chelsea Building Society",
  },
  {
    title: "Chorley Building Society",
    value: "Chorley Building Society",
  },
  {
    title: "Clydesdale Bank",
    value: "Clydesdale Bank",
  },
  {
    title: "Co-operative Bank",
    value: "Co-operative Bank",
  },
  {
    title: "Coutts",
    value: "Coutts",
  },
  {
    title: "Coventry Building Society",
    value: "Coventry Building Society",
  },
  {
    title: "Cumberland Building Society",
    value: "Cumberland Building Society",
  },
  {
    title: "Cynergy Bank",
    value: "Cynergy Bank",
  },
  {
    title: "Danske Bank",
    value: "Danske Bank",
  },
  {
    title: "Darlington Building Society",
    value: "Darlington Building Society",
  },
  {
    title: "Dudley Building Society",
    value: "Dudley Building Society",
  },
  {
    title: "Ecology Building Society",
    value: "Ecology Building Society",
  },
  {
    title: "Family Building Society",
    value: "Family Building Society",
  },
  {
    title: "First Direct",
    value: "First Direct",
  },
  {
    title: "Fleet Mortgages",
    value: "Fleet Mortgages",
  },
  {
    title: "Foundation Home Loans",
    value: "Foundation Home Loans",
  },
  {
    title: "Furness Building Society",
    value: "Furness Building Society",
  },
  {
    title: "Godiva Mortgages",
    value: "Godiva Mortgages",
  },
  {
    title: "Habito",
    value: "Habito",
  },
  {
    title: "Halifax",
    value: "Halifax",
  },
  {
    title: "Handelsbanken",
    value: "Handelsbanken",
  },
  {
    title: "Hanley Economic Building Society",
    value: "Hanley Economic Building Society",
  },
  {
    title: "Hodge Bank",
    value: "Hodge Bank",
  },
  {
    title: "HSBC",
    value: "HSBC",
  },
  {
    title: "Ipswich Building Society",
    value: "Ipswich Building Society",
  },
  {
    title: "Kent Reliance",
    value: "Kent Reliance",
  },
  {
    title: "Leeds Building Society",
    value: "Leeds Building Society",
  },
  {
    title: "Leek United Building Society",
    value: "Leek United Building Society",
  },
  {
    title: "LiveMore Capital",
    value: "LiveMore Capital",
  },
  {
    title: "Lloyds",
    value: "Lloyds",
  },
  {
    title: "Loughborough Building Society",
    value: "Loughborough Building Society",
  },
  {
    title: "M&S Bank",
    value: "M&S Bank",
  },
  {
    title: "Mansfield Building Society",
    value: "Mansfield Building Society",
  },
  {
    title: "Market Harborough Building Society",
    value: "Market Harborough Building Society",
  },
  {
    title: "Marsden Building Society",
    value: "Marsden Building Society",
  },
  {
    title: "Melton Mowbray Building Society",
    value: "Melton Mowbray Building Society",
  },
  {
    title: "Metro Bank",
    value: "Metro Bank",
  },
  {
    title: "Moda Mortgages",
    value: "Moda Mortgages",
  },
  {
    title: "Monmouthshire Building Society",
    value: "Monmouthshire Building Society",
  },
  {
    title: "The Mortgage Lender",
    value: "The Mortgage Lender Limited",
  },
  {
    title: "The Mortgage Works",
    value: "The Mortgage Works",
  },
  {
    title: "National Counties Building Society",
    value: "National Counties Building Society",
  },
  {
    title: "Nationwide",
    value: "Nationwide",
  },
  {
    title: "NatWest",
    value: "Natwest",
  },
  {
    title: "Newbury Building Society",
    value: "Newbury Building Society",
  },
  {
    title: "Newcastle Building Society",
    value: "Newcastle Building Society",
  },
  {
    title: "Nottingham Building Society",
    value: "Nottingham Building Society",
  },
  {
    title: "Paragon",
    value: "Paragon",
  },
  {
    title: "Penrith Building Society",
    value: "Penrith Building Society",
  },
  {
    title: "Pepper Money",
    value: "Pepper Money",
  },
  {
    title: "Perenna",
    value: "Perenna",
  },
  {
    title: "Platform",
    value: "Platform",
  },
  {
    title: "Post Office Money",
    value: "Post Office Money",
  },
  {
    title: "Precise Mortgages",
    value: "Precise Mortgages",
  },
  {
    title: "Principality Building Society",
    value: "Principality Building Society",
  },
  {
    title: "Reliance Bank",
    value: "Reliance Bank",
  },
  {
    title: "Royal Bank of Scotland",
    value: "Royal Bank of Scotland",
  },
  {
    title: "Stafford Railway Building Society",
    value: "Stafford Railway Building Society",
  },
  {
    title: "Saffron Building Society",
    value: "Saffron Building Society",
  },
  {
    title: "Santander",
    value: "Santander",
  },
  {
    title: "Scottish Building Society",
    value: "Scottish Building Society",
  },
  {
    title: "Scottish Widows",
    value: "Scottish Widows",
  },
  {
    title: "Selina Finance",
    value: "Selina Finance",
  },
  {
    title: "Skipton Building Society",
    value: "Skipton Building Society",
  },
  {
    title: "Suffolk Building Society",
    value: "Suffolk Building Society",
  },
  {
    title: "Teachers Building Society",
    value: "Teachers Building Society",
  },
  {
    title: "Tipton & Coseley Building Society",
    value: "Tipton & Coseley Building Society",
  },
  {
    title: "TSB Bank",
    value: "TSB",
  },
  {
    title: "Vernon Building Society",
    value: "Vernon Building Society",
  },
  {
    title: "Vida Homeloans",
    value: "Vida Homeloans",
  },
  {
    title: "Virgin Money",
    value: "Virgin Money",
  },
  {
    title: "West Bromwich Building Society",
    value: "West Bromwich Building Society",
  },
  {
    title: "Yorkshire Bank",
    value: "Yorkshire Bank",
  },
  {
    title: "Yorkshire Building Society",
    value: "Yorkshire Building Society",
  },
  {
    title: "Zephyr Homeloans",
    value: "Zephyr Homeloans",
  },
  {
    title: "Other",
    value: "Other",
  },
];

export const BUYING_PROOF_OF_FUNDS_OPTIONS = [
  {
    title: "Savings or investments",
    value: "Savings or investments",
    name: "cashAndSavings",
  },
  {
    title: "Mortgage",
    value: "Mortgage",
    name: "mortgage",
  },
  {
    title: "Sale of another property",
    value: "Selling another property",
    name: "sellingAnotherProperty",
  },
  {
    title: "Remortgage of another property",
    value: "Remortgaging another property",
    name: "remortgagingAnotherProperty",
  },
  {
    title: "Help to Buy ISA",
    value: "Help to Buy ISA",
    name: "helpToBuyIsa",
  },
  {
    title: "Lifetime ISA",
    value: "Lifetime ISA",
    name: "lifetimeIsa",
  },
  {
    title: "Inheritance (Gift of money from someone who has died)",
    value: "Inheritance",
    name: "inheritance",
  },
  {
    title: "Gift of money from someone who is alive",
    value: "Someone’s giving me money",
    name: "someoneGivingMeMoney",
  },
  {
    title: "Loan (not including a mortgage) from a person or bank",
    value: "Someone’s lending me money",
    name: "someoneLendingMeMoney",
  },
  {
    title: "Annual or one-off bonus from your employer",
    value: "Bonus from employer",
    name: "bonusFromEmployer",
  },
  {
    title: "Money from a Trust",
    value: "Money from a Trust",
    name: "trust",
  },
];

export const BUYING_PROOF_OF_FUNDS = BUYING_PROOF_OF_FUNDS_OPTIONS.reduce((obj, item) => {
  obj[item.name] = false;
  return obj;
}, {});

// The Trustpilot claim shown across the app: our TrustScore and review count, linked to our review
// profile. Update the count monthly; static-site holds the same claim in siteConfig.trustpilot.
// "Ranked No.1" was retired on 2 Oct 2026, when Trustpilot re-sorted category pages to weight review
// count over TrustScore. "Top-rated" was dropped on 6 Oct 2026 because the category page it linked to
// no longer lists us first; the 5.0 score stands up on its own.
const TRUSTPILOT_RATING = "5.0";
const TRUSTPILOT_REVIEW_FLOOR = "3,000";
const TRUSTPILOT_REVIEW_COUNT = `${TRUSTPILOT_REVIEW_FLOOR}+`;
export const TRUSTPILOT = {
  categoryUrl: "https://uk.trustpilot.com/categories/conveyancer",
  reviewUrl: "https://uk.trustpilot.com/review/www.juno.legal",
  // Short form, for headings and checklists: "Rated 5.0 on Trustpilot"
  ratingText: `Rated ${TRUSTPILOT_RATING} on Trustpilot`,
  // Long form, for sentences: "rated 5.0 out of 5 on Trustpilot from 3,000+ client reviews". Where
  // "Trustpilot" is a link, the copy is built from rating and reviewCount instead.
  ratingLongText: `rated ${TRUSTPILOT_RATING} out of 5 on Trustpilot from ${TRUSTPILOT_REVIEW_COUNT} client reviews`,
  rating: TRUSTPILOT_RATING,
  reviewCount: TRUSTPILOT_REVIEW_COUNT,
};

export const INSURANCE_LIMIT = 4000000;

export const HIGH_RISK_SECTORS = [
  { title: "Arms manufacturing or dealing", value: "arms_dealing" },
  { title: "Gambling", value: "gambling" },
  { title: "Cryptocurrencies or crypto-assets", value: "crypto" },
  { title: "Mining", value: "mining" },
  { title: "Dealing in art, gemstones or precious metals", value: "art_gems_metals" },
  { title: "An unregistered charity", value: "unregistered_charity" },
  { title: "None of the above", value: "none" },
];

// ISO Alpha-3 codes for territories we cannot act for, per the UK Money Laundering
// Regulations and our internal risk-management policy. Must match the codes emitted
// by `CountryPicker` (which uses `i18n-iso-countries`). North Cyprus is omitted —
// no separate ISO code exists, and rejecting all of CYP would be too broad.
//
// Sorted by country name. Source of truth (keep this list in sync when either is
// updated), last verified against both on 2026-07-07:
// - Spreadsheet: https://docs.google.com/spreadsheets/d/1M8Tg-fHAzpoKkk0-2BoSSLWkKARJtb3-oKkxuU6qv9o/edit?gid=2139274488#gid=2139274488
// - Guru card:   https://app.getguru.com/card/c9GrnMxi/Client-money-checks-high-risk-countries
export const HIGH_RISK_COUNTRY_CODES = new Set([
  "AFG", // Afghanistan
  "DZA", // Algeria
  "AGO", // Angola
  "BHR", // Bahrain
  "BLR", // Belarus
  "BOL", // Bolivia
  "BIH", // Bosnia and Herzegovina
  "VGB", // British Virgin Islands
  "BGR", // Bulgaria
  "BFA", // Burkina Faso
  "BDI", // Burundi
  "KHM", // Cambodia
  "CMR", // Cameroon
  "CYM", // Cayman Islands
  "CAF", // Central African Republic
  "CHN", // China
  "CIV", // Côte d’Ivoire
  "COD", // Democratic Republic of the Congo
  "GIN", // Guinea
  "GNB", // Guinea-Bissau
  "HTI", // Haiti
  "HKG", // Hong Kong
  "IRN", // Iran
  "IRQ", // Iraq
  "JOR", // Jordan
  "KAZ", // Kazakhstan
  "KEN", // Kenya
  "KWT", // Kuwait
  "LAO", // Laos
  "LBN", // Lebanon
  "LBY", // Libya
  "MAC", // Macao
  "MLI", // Mali
  "MDA", // Moldova
  "MCO", // Monaco
  "MNE", // Montenegro
  "MAR", // Morocco
  "MMR", // Myanmar
  "NAM", // Namibia
  "NPL", // Nepal
  "NIC", // Nicaragua
  "NGA", // Nigeria
  "PRK", // North Korea
  "OMN", // Oman
  "PAK", // Pakistan
  "PNG", // Papua New Guinea
  "QAT", // Qatar
  "RUS", // Russia
  "SAU", // Saudi Arabia
  "SRB", // Serbia
  "SOM", // Somalia
  "SSD", // South Sudan
  "SDN", // Sudan
  "SYR", // Syria
  "THA", // Thailand
  "TTO", // Trinidad and Tobago
  "TUN", // Tunisia
  "TKM", // Turkmenistan
  "UKR", // Ukraine
  "ARE", // United Arab Emirates
  "UZB", // Uzbekistan
  "VUT", // Vanuatu
  "VEN", // Venezuela
  "VNM", // Vietnam
  "YEM", // Yemen
  "ZWE", // Zimbabwe
]);
